import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { INewTopPage } from '../../interfaces/new-top-page';
import { CtaButtonComponent } from '../cta-button/cta-button.component';
import { RteComponent } from '../rte/rte.component';
import { TitleComponent } from '../title/title.component';
import { TrustpilotMicroStarComponent } from '../trustpilot-micro-star/trustpilot-micro-star.component';
import { CardsComponent } from './cards/cards.component';

@Component({
  selector: 'nscf-new-top-page-card',
  templateUrl: 'new-top-page-card.component.html',
  styleUrls: ['new-top-page-card.component.scss'],
  imports: [TitleComponent, RteComponent, CtaButtonComponent, CardsComponent, TrustpilotMicroStarComponent, NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewTopPageCardComponent {
  @Input() data: INewTopPage;
  @Input() bigViewPort: boolean;
}
